import { Editor as ReactPageEditor } from '@react-page/core/lib'

class Editor extends ReactPageEditor {
    setLibraryService(service) {
        this.libraryService = service
    }

    getLibraryService() {
        return this.libraryService
    }
}

export default Editor
